export default function ShareIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={`share-icon ${className}`}
      onClick={onClick}
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={`M249.41,113.45l157.14,136.55-157.14,136.56v-89.61c-58.92.13-98.95,3.16-155.94,43.73l-7.42,5.28.18-9.11c.03-1.45.96-35.73,22.08-70.49,12.46-20.48,29.36-36.79,50.26-48.49,24.86-13.93,55.4-21.28,90.84-21.86v-82.56M223.97,113.45v58.63c-29.35,3.14-55.45,11.04-77.84,23.59-24.75,13.87-44.79,33.2-59.55,57.47-24.19,39.8-25.69,78.85-25.78,83.17l-.18,9.13-.61,30.35c-.17,8.36,9.26,13.35,16.08,8.5l24.73-17.6,7.42-5.28c24.39-17.36,45.48-27.54,68.4-33.01,15.09-3.6,30.98-5.04,47.35-5.62v97.27c0,8.73,10.27,13.41,16.85,7.68l25.28-21.97,157.14-136.56,13.26-11.52c4.67-4.06,4.67-11.31,0-15.36l-13.26-11.52-157.14-136.55-25.28-21.97c-6.59-5.72-16.85-1.05-16.85,7.68v33.49Z`}
      />
    </svg>
  );
}
